export const addHttpErrorEvent = (params: { url: string; error: string }) => {
  process.client &&
    window.apmPlus?.('sendEvent', {
      name: 'HttpError',
      categories: {
        url: params.url,
        error: params.error,
      },
    });
};
